import { FRANCE_FR, PORTUGAL_PT, SPAIN_ES } from "@/config/app-constant";
import { ORIGIN_COUNTRY_API } from "@/constants";
import fetchPhoneNumberData from "@/hooks/magnolia/fetch-phone-number";
import { isHelpOverlayCallNumberBrandImpact } from "@/utils/help-overlay.utils";

export const getOriginCountryData = async (): Promise<string | null> => {
  try {
    const response = await fetch(ORIGIN_COUNTRY_API);
    if (!response.ok) throw new Error("Failed to fetch origin country");

    const data = await response.json();
    return data.country;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error fetching origin country:", error);
    return null;
  }
};

interface PhoneNumberEntry {
  desktop: string;
  mobile: string;
  name: string;
  default: string;
  "@path": string;
}

export const getPhoneNumberByCountry =
  async (): Promise<PhoneNumberEntry | null> => {
    try {
      // Fetch country name and phone numbers in parallel
      const [countryName, phoneNumbersResponse] = await Promise.all([
        isHelpOverlayCallNumberBrandImpact
          ? getOriginCountryData()
          : Promise.resolve(null),
        fetchPhoneNumberData(),
      ]);

      if (!phoneNumbersResponse?.results?.length) {
        return null;
      }

      const filteredPhoneNumbers = phoneNumbersResponse.results.filter(
        (phoneNumber) => phoneNumber["@path"].startsWith("/expat/help-overlay/")
      );

      const normalizedCountry = countryName?.trim().toLowerCase() ?? "";
      const validCountries = [SPAIN_ES, FRANCE_FR, PORTUGAL_PT].map((c) =>
        c.toLowerCase()
      );

      // Check if country is valid
      if (!validCountries.includes(normalizedCountry)) {
        return (
          filteredPhoneNumbers.find(
            (phoneNumber) => phoneNumber.name.trim().toLowerCase() === "default"
          ) ?? null
        );
      }

      // Find phone num matching the country
      return (
        filteredPhoneNumbers.find(
          (phoneNumber) =>
            phoneNumber.name.trim().toLowerCase() === normalizedCountry
        ) ?? null
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error fetching phone number:", error);
      return null;
    }
  };
